import { Calendar } from 'antd';
import styled from 'styled-components';

export default styled(Calendar)`
	// Add your styles here
`;
